export default __webpack_public_path__ + "static/customer-service-management_app_dark-cdfc74fb6020c45f9a6798333147f61be75fe1288885da16e5981fea50d4ac04.svg";